import * as React from "react";
import "../Sidebar/Sidebar.css";
import { styled } from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { Link, useNavigate } from "react-router-dom";
// import JobsLogo from "../../Assets/JOI.jpg"
import JobsLogo from "../../Assets/JobsOhio_Primary.png"
// import JobsLogo from "../../Assets/eicilogo.png"

import ListAltIcon from '@mui/icons-material/ListAlt';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import joitraining from '../../Assets/joitraining.svg'
import { alpha } from "@mui/material/styles";
import cellphone from '../../Assets/cellphone.svg'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { ABOUT, CONTACT_US, DAILY_VIEW, DASHBOARD, LIST_VIEW, MONTHLY_VIEW, TRAINING, WEEKLY_VIEW } from "../../Utils/Constants";
import { GetOktaAuthData, GetUserId } from "../../Utils/Utils";
import { Button } from "@mui/material";
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";
import { useOktaAuth } from "@okta/okta-react";
import logout from "../../Assets/logouthead.png";
import HeaderSearch from "../HeaderSearch/HeaderSearch";
import Loader from "../Loader/Loader";

const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});
const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});
const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));
const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));
const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));
const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

export default function Sidebar() {
  const navigate = useNavigate();
  const { oktaAuth } = useOktaAuth();
  const getAuthData = GetOktaAuthData();
  const [loading, setLoading] = React.useState(false)
  const [open, setOpen] = React.useState(true);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openLogout = Boolean(anchorEl);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleDrawerOpen = () => {
    setOpen(!open);
  };
  // const [openDashboard, setOpenDashboard] = React.useState(false);
  // React.useEffect(() => {
  //   if (window.location.pathname == WEEKLY_VIEW || window.location.pathname == DAILY_VIEW || window.location.pathname == MONTHLY_VIEW) {
  //     setOpenDashboard(true)
  //   }
  // }, [])

  const loggingOut = async () => {
    await oktaAuth.signOut({
      postLogoutRedirectUri: window.location.origin + "/",
      clearTokensBeforeRedirect: true,
    });
    localStorage.clear();
    sessionStorage.clear();
  };

  React.useEffect(() => {
    if (!GetUserId()) {
      navigate("/")
    }
  }, [])
  return (
    <>
      {loading ? <Loader /> : null}
      <CssBaseline />
      <AppBar position="fixed" open={open} className={open ? "main-header" : "main-headernew"}>
        <Toolbar className="toolbar-header">
          <div className="bellicon-profileimage">
            <div className="searchbar-name-header">
              <HeaderSearch loading={loading} setLoading={setLoading} />
            </div>
            <div className="image-and-information">
              <div className="header-user-name">
                <p>{getAuthData?.user?.profile?.firstName?.charAt(0)}{getAuthData?.user?.profile?.lastName?.charAt(0)}</p>
              </div>
              <p className="username-header-cal">{`${getAuthData?.user?.profile?.firstName} ${getAuthData?.user?.profile?.lastName}`}
              </p>
              <div className="username-and-role">
                <p className="user-name-header">
                </p>
              </div>
            </div>
            <div className="Leades-filter-inner-container-header">
              <Button
                style={{ textTransform: "none" }}
                id="action-button"
                aria-controls={openLogout ? "action-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={openLogout ? "true" : undefined}
                variant="contained"
                disableElevation
                onClick={handleMenuClick}
                endIcon={
                  <ExpandMoreOutlinedIcon className="down-arrow-header" />
                }
              ></Button>
              <StyledMenu
                className="custom-menu"
                id="action-menu"
                MenuListProps={{
                  "aria-labelledby": "action-button",
                }}
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
              >
                <div>
                  <MenuItem
                    className="AI-Leads-button-drop-down-up-header"
                    onClick={handleMenuClose}
                    disableRipple
                  >
                    <p
                      className="push-to-slaesforce-in-button"
                      onClick={() => loggingOut()}
                    >
                      <span className="head-drop-menu"><img src={logout} alt="logout" /></span>
                      Logout
                    </p>
                  </MenuItem>
                </div>
              </StyledMenu>
            </div>
          </div>
          <IconButton
            className="Siderbarresponsivebutton"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>

      </AppBar>
      <Drawer className={open ? "mobileresponsiveMaincsss" : "mobileresponsiveMaincsssnew"} variant="permanent" open={open}>
        <DrawerHeader className={`${open ? "header-section-sidebar" : ""}`}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Link to={'/dashboard'} style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}>
              <img
                src={JobsLogo}
                alt="logo"
                className="logo-image-of-the-project"
              />
            </Link>
          </div>

        </DrawerHeader>
        <div className="main-sidebar-pages-and-addsearch-data">
          <div className="all-sidebar-listitems">

            {/* Dashboard  */}

            <List>
              <ListItem
                disablePadding
                sx={{ display: "block" }}
                className="links-sidebar"
              >
                <ListItemButton
                  component={Link}
                  to={DASHBOARD}
                  selected={window.location.pathname === DASHBOARD}
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <span className="outer_circle_sidebar_icon">
                      <CalendarMonthIcon />
                    </span>
                  </ListItemIcon>
                  <ListItemText
                    primary={"Calendar "}
                    sx={{ opacity: open ? 1 : 0 }}
                  />
                </ListItemButton>
              </ListItem>
            </List>
            {/* <List>
              <ListItem
                disablePadding
                sx={{ display: "block" }}
                className="links-sidebar"
              >

                <ListItemButton
                  component={Link}
                  className="help-center-container"
                  onClick={handleDashboardClick}
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <span className="outer_circle_sidebar_icon">
                      <CalendarMonthIcon />
                    </span>
                  </ListItemIcon>
                  <ListItemText
                    primary="Calendar"
                    sx={{ opacity: open ? 1 : 0 }}
                  />
                  <ChevronDownIcon
                    sx={{
                      ml: 1,
                      transform: openDashboard ? 'rotate(270deg)' : 'rotate(90deg)',
                      transition: 'transform 0.3s ease',
                      color: '#da291c'
                    }}
                  />
                </ListItemButton>
              </ListItem>

              {openDashboard && (
                <List component="div" disablePadding>
                  <ListItem
                    disablePadding
                    sx={{ display: 'block' }}
                    className="links-sidebar-inner"
                    onClick={handleDashboardClick}

                  >
                    <ListItemButton
                      component={Link}
                      to={WEEKLY_VIEW}
                      selected={window.location.pathname === WEEKLY_VIEW}
                      sx={{
                        minHeight: 48,
                        justifyContent: open ? 'initial' : 'center',
                        px: 2.5,
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : "auto",
                          justifyContent: "center",
                        }}
                      >
                        <span className="outer_circle_sidebar_icon">
                          <ViewWeekIcon />
                        </span>
                      </ListItemIcon>
                      <ListItemText
                        primary="Weekly View"
                        sx={{ opacity: open ? 1 : 0 }}
                      />
                    </ListItemButton>
                  </ListItem>

                  <ListItem
                    disablePadding
                    sx={{ display: 'block' }}
                    className="links-sidebar-inner"
                  >
                    <ListItemButton
                      component={Link}
                      to={DAILY_VIEW}
                      selected={window.location.pathname === DAILY_VIEW}
                      sx={{
                        minHeight: 48,
                        justifyContent: open ? 'initial' : 'center',
                        px: 2.5,
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : "auto",
                          justifyContent: "center",
                        }}
                      >
                        <span className="outer_circle_sidebar_icon">
                          <EventIcon />
                        </span>
                      </ListItemIcon>

                      <ListItemText
                        primary="Daily View"
                        sx={{ opacity: open ? 1 : 0 }}
                      />
                    </ListItemButton>
                  </ListItem>
                  <ListItem
                    disablePadding
                    sx={{ display: 'block' }}
                    className="links-sidebar-inner"
                  >
                    <ListItemButton
                      component={Link}
                      to={MONTHLY_VIEW}
                      selected={window.location.pathname === MONTHLY_VIEW}
                      sx={{
                        minHeight: 48,
                        justifyContent: open ? 'initial' : 'center',
                        px: 2.5,
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : "auto",
                          justifyContent: "center",
                        }}
                      >
                        <span className="outer_circle_sidebar_icon">
                          <CalendarViewMonthIcon />
                        </span>
                      </ListItemIcon>


                      <ListItemText
                        primary="Monthly View"
                        sx={{ opacity: open ? 1 : 0 }}
                      />
                    </ListItemButton>
                  </ListItem>
                </List>
              )}
            </List> */}
            {/* List View  */}
            <List>
              <ListItem
                disablePadding
                sx={{ display: "block" }}
                className="links-sidebar"
              >
                <ListItemButton
                  component={Link}
                  to={LIST_VIEW}
                  selected={window.location.pathname === LIST_VIEW}
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <span className="outer_circle_sidebar_icon">
                      <ListAltIcon />
                    </span>
                  </ListItemIcon>
                  <ListItemText
                    primary={"Category View"}
                    sx={{ opacity: open ? 1 : 0 }}
                  />
                </ListItemButton>
              </ListItem>
            </List>

            {/* About  */}
            <List>
              <ListItem
                disablePadding
                sx={{ display: "block" }}
                className="links-sidebar"
              >
                <ListItemButton
                  component={Link}
                  to={ABOUT}
                  selected={window.location.pathname === ABOUT}
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <span className="outer_circle_sidebar_icon">
                      <InfoOutlinedIcon />
                    </span>
                  </ListItemIcon>
                  <ListItemText
                    primary={"About "}
                    sx={{ opacity: open ? 1 : 0 }}
                  />
                </ListItemButton>
              </ListItem>
            </List>

            {/* Training  */}
            <List>
              <ListItem
                disablePadding
                sx={{ display: "block" }}
                className="links-sidebar"
              >
                <ListItemButton
                  component={Link}
                  to={TRAINING}
                  selected={window.location.pathname === TRAINING}
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <span className="outer_circle_sidebar_icon">
                      <img src={joitraining} alt="" />
                    </span>
                  </ListItemIcon>
                  <ListItemText
                    primary={"Training"}
                    sx={{ opacity: open ? 1 : 0 }}
                  />
                </ListItemButton>
              </ListItem>
            </List>

            {/* Contact us  */}
            <List>
              <ListItem
                disablePadding
                sx={{ display: "block" }}
                className="links-sidebar"
              >
                <ListItemButton
                  component={Link}
                  to={CONTACT_US}
                  selected={window.location.pathname === CONTACT_US}
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <span className="outer_circle_sidebar_icon">
                      <img src={cellphone} alt="" />
                    </span>
                  </ListItemIcon>
                  <ListItemText
                    primary={"Contact Us "}
                    sx={{ opacity: open ? 1 : 0 }}
                  />
                </ListItemButton>
              </ListItem>
            </List>

            {/* old code for dashboard  */}

            {/* <List>
              <ListItem
                disablePadding
                sx={{ display: "block" }}
                className="links-sidebar"
              >
                <ListItemButton
                  component={Link}
                  to={DASHBOARD}
                  selected={window.location.pathname === DASHBOARD}
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <span className="outer_circle_sidebar_icon">
                      <CalendarMonthIcon />
                    </span>
                  </ListItemIcon>
                  <ListItemText
                    primary={"Calendar "}
                    sx={{ opacity: open ? 1 : 0 }}
                  />
                </ListItemButton>
              </ListItem>
            </List> */}
          </div>
        </div>
      </Drawer>
    </>
  );
}
